// Shared helpers for formatting backend error payloads for display.
//
// FastAPI's default RequestValidationError handler returns 422 bodies shaped
// like `{"detail": [{"loc": [...], "msg": "...", "type": "..."}, ...]}` —
// `detail` is an ARRAY OF OBJECTS, not a string. Rendering that array
// directly as a JSX child (e.g. `{error}`) throws "Objects are not valid as
// a React child" and crashes the whole view. These helpers normalize any
// shape of `detail` into a safe, human-readable string.
export function formatErrorDetail(detail, fallback) {
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((item) => (item && typeof item.msg === "string" ? item.msg : null))
      .filter(Boolean);
    if (msgs.length) return msgs.join("; ");
  } else if (detail && typeof detail === "object" && typeof detail.message === "string") {
    return detail.message;
  }
  return fallback;
}

// Convenience wrapper for the common `catch (err) { ... }` call sites —
// pulls `detail` off the axios error shape and formats it.
export function extractErrorDetail(err, fallback) {
  return formatErrorDetail(err?.response?.data?.detail, fallback);
}
